<template>
    <div>
        <el-dialog title="新增商业承兑汇票项目" :visible.sync="isAcceptanceAdd" center :before-close="onClose" width="1200px" :close-on-click-modal="false">
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            客户名称：
                        </div>
                        <div>
                            <span style="margin-right: 10px; font-size: 12px" v-if="params.Credit_Control_CustomerName">{{ params.Credit_Control_CustomerName }}</span>
                            <el-button type="primary" size="mini" @click="onOpenCustomer()">查询客户</el-button>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            初始状态：
                        </div>
                        <el-select v-model="params.Credit_CommercialBill_State" placeholder="请选择项目类型" class="el-select-max" value-key="ID">
                            <el-option label="请选择项目类型" :value="-1"></el-option>
                            <el-option v-for="item in StateList" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            经办人：
                        </div>
                        <el-select v-model="params.Credit_CommercialBill_Agent" placeholder="请选择经办人" class="el-select-max" filterable value-key="ID">
                            <el-option label="请选择经办人" :value="0"></el-option>
                            <el-option v-for="item in Control_Agentopt" :key="item.ID" :label="item.ShowName" :value="item.ID"></el-option>
                        </el-select>
                    </div>
                </el-col>

                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            项目金额：
                        </div>
                        <div>
                            <el-input v-model="params.Credit_CommercialBill_ProjectMoney" clearable class="el-select-max" @input="handleInput($event, 'params', 'Credit_Control_ProjectMoney')"></el-input>
                        </div>
                    </div>
                </el-col>

                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            汇票编号：
                        </div>
                        <div>
                            <el-input v-model="params.Credit_CommercialBill_SN" clearable class="el-select-max"></el-input>
                        </div>
                    </div>
                </el-col>

                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            汇票类型：
                        </div>
                        <div>
                            <el-radio-group v-model="params.Credit_CommercialBill_Type">
                                <el-radio :label="0">纸质</el-radio>
                                <el-radio :label="1">电子</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            出票日期：
                        </div>
                        <div>
                            <el-date-picker v-model="params.IssueDate" class="el-select-max" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable></el-date-picker>
                        </div>
                    </div>
                </el-col>

                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            到期日期：
                        </div>
                        <div>
                            <el-date-picker v-model="params.DueDate" class="el-select-max" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable></el-date-picker>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            承兑人：
                        </div>
                        <div>
                            <el-input v-model="params.Credit_CommercialBill_Acceptor" placeholder="" clearable class="el-select-max"></el-input>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            前手背书人：
                        </div>
                        <div>
                            <el-input v-model="params.Credit_CommercialBill_FormerEndorser" placeholder="" clearable class="el-select-max"></el-input>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">混合付款ID：</div>
                        <div>
                            <el-input v-model="params.Credit_CommercialBill_PaymentID" placeholder="" clearable class="el-select-max"></el-input>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24" v-if="isCheckUpload">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">附件：</div>
                        <div>
                            <Hwupload ref="Hwupload" v-if="isAcceptanceAdd" />
                        </div>
                    </div>
                </el-col>
            </el-row>

            <span slot="footer" class="dialog-footer">
                <el-button @click="onClose()">取 消</el-button>
                <el-button type="primary" @click="onSubmit()">保存</el-button>
            </span>
        </el-dialog>
        <el-dialog title="查找客户" :visible.sync="isShowdialog" width="600px" :before-close="onCloseCustomer" :close-on-click-modal="false">
            <div class="client">
                <div class="client-head">
                    <el-input v-model="Customer_Name" clearable class="el-select-big" placeholder="请数据客户名称全称检索"></el-input>
                    <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="getSelectCreditCustomer()" :loading="isLoading">检索</el-button>
                </div>
                <el-table :data="Customer_list" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" :loading="isLoading">
                    <el-table-column label="客户名称" align="center">
                        <template slot-scope="scope">
                            <el-radio @input="onInputCustomerId($event, scope.row)" v-model="selectedRowId" :label="scope.row.Credit_Customer_ID">{{ scope.row.Credit_Customer_Name }}</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Credit_Customer_UniformCode" label="客户编号" align="center"></el-table-column>
                </el-table>
            </div>

            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center" v-if="selectedRowId">
                <el-button @click="onCloseCustomer()">取消</el-button>
                <el-button type="primary" @click="onSaveCustomerId()">保存</el-button>
            </span>
            <div v-else style="height: 62px"></div>
        </el-dialog>
    </div>
</template>

<script>
import { cloneDeep, debounce } from 'lodash';
import { toLowerCaseKeys } from '@/utils/utils.js';
import Hwupload from '@/components/Hwupload/index.vue';
export default {
    components: {
        Hwupload
    },
    props: {
        isAcceptanceAdd: {
            type: Boolean,
            default: false
        },
        StateList: {
            type: Array,
            default: () => []
        },
        isCheckUpload: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isShowdialog: false,
            Customer_Name: '',
            Credit_Control_CustomerName: '',
            isLoading: false,
            selectedRowId: null,
            params: {
                Credit_Control_CustomerName: '',
                Credit_Control_CustomerID: '',
                Credit_CommercialBill_State: 1,
                Credit_CommercialBill_Agent: 0,
                Select_OfficeMember: '',
                Credit_CommercialBill_ProjectMoney: '',
                Credit_CommercialBill_SN: '',
                Credit_CommercialBill_Type: 0,
                IssueDate: '',
                DueDate: '',
                Credit_CommercialBill_Acceptor: '',
                Credit_CommercialBill_FormerEndorser: '',
                Credit_CommercialBill_PaymentID: '',
                Credit_Remarks: '',
                action: 'new'
            },
            Control_Typeopt: [],
            Control_Agentopt: [],
            Customer_list: []
        };
    },
    watch: {
        isAcceptanceAdd(newval) {
            if (newval) {
                this.getOfficeMemberSelectOption();
            }
        }
    },
    methods: {
        onSubmit: debounce(function () {
            const params = cloneDeep(this.params);
            params.Credit_Remarks = this.$refs.Hwupload.filePath;
            const result = {
                json: JSON.stringify(toLowerCaseKeys(params))
            };
            this.$newsApi.getAddCreditCommercialBill(result).then((res) => {
                if (res.data.Resultcode === 0) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2000,
                        onClose: () => {
                            this.$emit('onClose', true);
                        }
                    });
                }
            });
        }, 800),
        onClose() {
            this.$emit('onClose');
        },
        getSelectCreditCustomer() {
            this.isLoading = true;
            this.$newsApi
                .getSelectCreditCustomer({ Customer_Name: this.Customer_Name })
                .then((res) => {
                    if (res.data.Resultcode === 0) {
                        this.Customer_list = res.data.data;
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        onOpenCustomer() {
            this.Customer_Name = '';
            this.selectedRowId = null;
            this.isShowdialog = true;
            this.Customer_list = [];
        },
        onSaveCustomerId() {
            if (this.selectedRowId) {
                this.params.Credit_Control_CustomerID = this.selectedRowId;
                this.params.Credit_Control_CustomerName = this.Credit_Control_CustomerName;
                this.isShowdialog = false;
            }
        },
        onCloseCustomer() {
            this.isShowdialog = false;
        },
        onInputCustomerId(e, row) {
            this.selectedRowId = row.Credit_Customer_ID;
            this.Credit_Control_CustomerName = row.Credit_Customer_Name;
        },
        getOfficeMemberSelectOption() {
            this.$newsApi.getOfficeMemberSelectOption().then((res) => {
                if (res.data.Resultcode === 0) {
                    this.Control_Agentopt = res.data.data;
                }
            });
        },
        handleInput(value, obj, key) {
            const cleanedValue = value.replace(/[^\d.]/g, '');
            const regex = /^\d*\.?\d*$/;
            if (regex.test(cleanedValue)) {
                this[obj][key] = cleanedValue.startsWith('.') ? '0' + cleanedValue : cleanedValue;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.required {
    color: red;
    margin-left: 4px;
}

.client {
    margin-bottom: 20px;

    .client-head {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
}

.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 120px;
    }
}
</style>
